import {
  HakajimaiRequestProps,
  requestHandler
} from '@/runtimes/ohaka/hakajimai_requests/new/new'
import { HakajimaiRequest } from '@/contents/new/HakajimaiRequest/HakajimaiRequest'

export const getServerSideProps = requestHandler

const HakajimaiRequestFormPage = ({ guidebook }: HakajimaiRequestProps) => {
  return <HakajimaiRequest guidebook={guidebook} />
}

export default HakajimaiRequestFormPage
